<template>
  <div>
    <md-dialog v-dialogDrag :visible.sync="visible" top="80px" width="500px" :title="title" :close-on-click-modal="false" append-to-body :before-close="beforeClose">
      <md-form :model="form" :rules="rules" ref="form" labmd-width="100px" class="my-form" :disabled="readonly">
        <md-form-item label="角色名称" prop="roleNameZh">
          <md-input v-model="form.roleNameZh"></md-input>
        </md-form-item>
        <md-form-item label="角色标识" prop="roleCode">
          <md-input v-model="form.roleCode" :disabled="!!form.baseRoleId"></md-input>
        </md-form-item>
        <md-form-item label="是否有效" prop="status">
          <md-switch v-model="form.status" active-value="Y" inactive-value="N" activeText="否" inactiveText="是"></md-switch>
        </md-form-item>
         <md-form-item label="排序" prop="sort">
          <md-input v-model="form.sort" @input="form.sort=form.sort.replace(/^0|[^\d]+/g,'')"></md-input>
        </md-form-item>
        <md-form-item label="角色描述" prop="descZh" style="margin-bottom: 0px">
          <md-input type="textarea" v-model="form.descZh"></md-input>
        </md-form-item>
      </md-form>
      <div style="margin-top: 20px; height: 30px">
        <md-button type="primary" style="float: right" @click="submitForm">确定</md-button>
        <md-button
          v-if="!readonly"
          style="float: right; margin-right: 10px"
          @click="
            () => {
              $emit('closeDialog');
            }
          "
        >
          取消
        </md-button>
      </div>
    </md-dialog>
  </div>
</template>
<script>
export default {
  name: 'addDialog',
  props: {
    options: {
      type: Array,
      default: () => [],
    }, // 角色类型下拉
  },
  data() {
    return {
      title: '新增角色',
      visible: false,
      readonly: false,
      form: {
        roleNameZh: '',
        roleCode: '',
        descZh: '',
        status: 'Y',
        sort: '',
      },
      rules: {
        roleNameZh: [{ required: true, message: '请输入角色名称', trigger: 'change' }],
        roleCode: [{ required: true, message: '请输入角色标识', trigger: 'change' }],
      },
    };
  },
  methods: {
    // -------------------菜单名称-----------------
    // 增加语言
    addLanguage(type) {
      let listName = '';
      if (type === 'name') {
        listName = 'nameLanguageList';
      } else {
        listName = 'descLanguageList';
      }
      if (this[listName][0].show) {
        this[listName][1].show = true;
      } else {
        this[listName][0].show = true;
      }
    },
    // 删除语言
    deleteLanguage(row) {
      row.show = false;
      this.form[row.model] = '';
    },

    // -------------------图标选择-----------------
    iconChoose() {
      this.iconDialog.visible = true;
    },
    selectedIcon(iconName) {
      this.form.iconUrl = iconName;
      this.iconDialog.visible = false;
    },

    // -------------------按钮-----------------
    beforeClose() {
      this.$emit('closeDialog');
    },
    // 确认
    submitForm() {
      if (this.readonly) {
        this.$emit('closeDialog');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('sbmitForm', this.form);
        }
      });
    },
  },
};
</script>

<style lang="less">
.my-form {
  width: 100%;
  .md-input {
    padding-bottom: 10px;
  }
  .el-input-group__prepend {
    width: 70px;
    text-align: center;
    padding: 0 4px;
  }
  .el-input-group__append {
    width: 50px;
    text-align: center;
    padding: 0 4px;
    button {
      border: none;
      background: rgba(0, 0, 0, 0);
      padding: 0;
      // margin-right: 8px;
      &:hover {
        background: rgba(0, 0, 0, 0);
        color: rgb(127, 127, 253);
      }
    }
  }
  .el-form-item__label {
    width: 100px;
  }
  .el-form-item__content {
    padding-left: 100px;
  }
  .md-col {
    .el-form-item__content {
      padding-left: 0;
    }
  }
  .el-date-editor.el-input {
    width: auto;
  }
  .line {
    text-align: center;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
  .el-form-item__error {
    left: 100px;
  }
  .mdDatePicker + .el-form-item__error,
  .md-time-picker + .el-form-item__error {
    left: 0;
  }
  .md-select {
    .el-input__inner {
      width: 360px;
    }
  }
  .md-textarea {
    width: 360px;
    .el-textarea__inner {
      height: 120px;
    }
  }
  .el-checkbox .el-checkbox__label {
    padding-left: 4px;
  }
}

// 图标弹框相关
.fas-icon-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.fas-icon-list li {
  margin: 10px 10px;
}
.fas {
  font-size: 30px;
  color: #000000;
  cursor: pointer;
}
</style>
